import { render } from "./home-three-about.vue?vue&type=template&id=c9a310fa"
import script from "./home-three-about.vue?vue&type=script&lang=js"
export * from "./home-three-about.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__